import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Study = _resolveComponent("Study")!
  const _component_Country = _resolveComponent("Country")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_ctx.isApplicationReady)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.page === 'Study')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_Study)
            ]))
          : _createCommentVNode("v-if", true),
        (_ctx.page === 'Country')
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_Country)
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        (!_ctx.isApplicationIdle)
          ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
          : _createCommentVNode("v-if", true)
      ]))
}